/**
 * Navigation Icon Color Configuration
 * 
 * Defines section-specific colors for sidebar navigation icons.
 * - Inactive: colored icon on white background
 * - Active: white icon on soft tinted background
 */

export const navigationColors = {
  '/dashboard': {
    icon: '#64748B',           // neutral slate
    activeBg: '#F1F5F9',       // slate-100
    activeIcon: '#FFFFFF'
  },
  '/how-to-use': {
    icon: '#0EA5E9',           // sky blue (guidance, calm)
    activeBg: '#E0F2FE',       // sky-100
    activeIcon: '#FFFFFF'
  },
  '/blood-results': {
    icon: '#B91C1C',           // deep medical red
    activeBg: '#FEE2E2',       // red-100
    activeIcon: '#FFFFFF'
  },
  '/nutrition': {
    icon: '#15803D',           // health green
    activeBg: '#DCFCE7',       // green-100
    activeIcon: '#FFFFFF'
  },
  '/vitamins': {
    icon: '#15803D',           // same green as nutrition
    activeBg: '#DCFCE7',       // green-100
    activeIcon: '#FFFFFF'
  },
  '/symptoms': {
    icon: '#D97706',           // amber
    activeBg: '#FEF3C7',       // amber-100
    activeIcon: '#FFFFFF'
  },
  '/medications': {
    icon: '#1D4ED8',           // clinical blue
    activeBg: '#DBEAFE',       // blue-100
    activeIcon: '#FFFFFF'
  },
  '/integrative-health': {
    icon: '#0F766E',           // teal
    activeBg: '#CCFBF1',       // teal-100
    activeIcon: '#FFFFFF'
  },
  '/education': {
    icon: '#4338CA',           // indigo
    activeBg: '#E0E7FF',       // indigo-100
    activeIcon: '#FFFFFF'
  },
  '/reading-learning': {
    icon: '#4F46E5',           // indigo-600 (learning, educational)
    activeBg: '#E0E7FF',       // indigo-100
    activeIcon: '#FFFFFF'
  },
  '/common-questions': {
    icon: '#7C3AED',           // violet (helpful, question-focused)
    activeBg: '#EDE9FE',       // purple-100
    activeIcon: '#FFFFFF'
  },
  '/updates-learning': {
    icon: '#475569',           // slate-600 (news, updates)
    activeBg: '#F1F5F9',       // slate-100
    activeIcon: '#FFFFFF'
  },
  '/glossary': {
    icon: '#6D28D9',           // muted purple
    activeBg: '#EDE9FE',       // purple-100
    activeIcon: '#FFFFFF'
  },
  '/alerts': {
    icon: '#DC2626',           // alert red
    activeBg: '#FEE2E2',       // red-100
    activeIcon: '#FFFFFF'
  },
  '/export': {
    icon: '#374151',           // charcoal
    activeBg: '#F3F4F6',       // gray-100
    activeIcon: '#FFFFFF'
  },
  '/admin': {
    icon: '#D97706',           // amber (admin special)
    activeBg: '#FEF3C7',       // amber-100
    activeIcon: '#D97706'      // keep amber for admin active state
  }
};

/**
 * Get navigation color configuration for a given path
 */
export const getNavColors = (path) => {
  return navigationColors[path] || {
    icon: '#64748B',
    activeBg: '#F1F5F9',
    activeIcon: '#FFFFFF'
  };
};
